import { render, staticRenderFns } from "./simpleModel.vue?vue&type=template&id=1f6ce4fc&scoped=true&"
import script from "./simpleModel.vue?vue&type=script&lang=js&"
export * from "./simpleModel.vue?vue&type=script&lang=js&"
import style0 from "./simpleModel.vue?vue&type=style&index=0&id=1f6ce4fc&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ce4fc",
  null
  
)

export default component.exports